import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=1e05a24d&scoped=true&"
import script from "./AreaTable.vue?vue&type=script&lang=js&"
export * from "./AreaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05a24d",
  null
  
)

export default component.exports